// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"47daf16151d78e26","4001":"adde3a5956505985","8289":"3f3e1e3a3a732e0e"}[chunkId] + ".css";
};